// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1a1Zw","approved":"Status_approved__1-DZC","rejected":"Status_rejected__1nuT4","expired":"Status_expired__2HtFT","label":"Status_label__21Wwg"};